import { LinearProgress, Stack } from '@mui/material';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Unstable_Grid2';
import Divider from '@mui/material/Divider/Divider';
import { useContext } from 'react';
import { Order, Shipment } from '../../../Models';
import PatientInfoSection from './PatientInfoSection';
import ProductsTableSection from './ProductsTableSection';
import PaymentInfoSection from './PaymentInfoSection';
import FilesInfoSection from './FilesInfoSection';
import { useGetSettlement } from '../../../services/api/queries/useGetSettlement';
import ShippingInfoSection from './ShippingInfoSection';
import { ShipmentsContext } from '../../../services/Deliveries';
import TitleBar from './TitleBar';
import { useGetShipment } from '../../../services/api/queries/useGetShipment';

type RowDetailProps = {
    order: Order;
};
export function RowDetailPanel({ order }: RowDetailProps) {
    const { settlement, isFetching, isError } = useGetSettlement(order.id);
    const { shipments } = useContext(ShipmentsContext);
    // falta campos de reembolsos
    const shipmentFromContext: Shipment | undefined = shipments[order.delivery_id || ''];
    const { shipment: shipmentFromQuery } = useGetShipment(
        !shipmentFromContext ? order.delivery_id : '',
    );
    const shipment = shipmentFromContext || shipmentFromQuery;

    if (isError) {
        return null;
    }
    if (isFetching || !settlement) {
        return <LinearProgress sx={{ margin: 'auto' }} />;
    }
    return (
        <Stack sx={{ p: 2, height: '100%', boxSizing: 'border-box' }} direction="column">
            <Box width={{ lg: '80%', md: '70%', sm: '100%' }} sx={{ flex: 1, mx: 'auto' }}>
                <Grid container spacing={2}>
                    <Grid sm={12}>
                        <TitleBar settlement={settlement} order={order} />
                    </Grid>
                    <Grid xs={12} lg={6}>
                        <Stack
                            spacing={2}
                            sx={{ p: 2, borderRadius: 2, border: 0.5, borderColor: 'gray' }}>
                            <PatientInfoSection order={order} />
                            {/* <Divider sx={{mb:1}}/> */}
                            <ShippingInfoSection order={order} shipment={shipment} />
                        </Stack>
                    </Grid>
                    <Grid xs={12} lg={6}>
                        <Box sx={{ p: 2, borderRadius: 2, border: 0.5, borderColor: 'gray' }}>
                            <PaymentInfoSection settlement={settlement} order={order} />
                        </Box>
                    </Grid>
                    <Grid xs={12}>
                        <ProductsTableSection settlement={settlement} order={order} />
                    </Grid>
                    <Grid xs={12}>
                        <Box sx={{ p: 2, borderRadius: 2, border: 0.5, borderColor: 'gray' }}>
                            <FilesInfoSection row={order} />
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        </Stack>
    );
}
